import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { OrgSwitcherService } from '../../page/page-wrapper/org-switcher/org-switcher.service';

/**
 * Guard to prevent access to routes if the user has any role assignments
 */
export const noOrgGuard: CanActivateFn = async (
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
): Promise<boolean | UrlTree> => {
    const orgSwitcherService = inject(OrgSwitcherService);
    const router = inject(Router);

    const orgs = await firstValueFrom(orgSwitcherService.userOrgs$);
    if (orgs.length > 0) {
        return router.parseUrl('/');
    }
    return true;
};
